import { TradingBox } from "../../styles/BoxingStyles";
import {TradeHead, TradeWrapper, TypeTab, TypeWrapper} from "../../styles/TradeStyles";
import {HText, FlexCenter, Padding, FlexStart,} from "../../styles/CommonStyles"
import Text from "../../utils/Text"
import TradeType from "./TradeType";
import Invoice from "../common/Invoice";
import ModalLayout from "../../layouts/ModalLayout";
import {useWindowSize} from "../../hooks/common/useWindowSize";
import {MOBILE_SIZE, TABLET_SIZE} from "../../constants/common";
import useTradingSpot from "../../hooks/useTradingSpot";

const TradingComp = () => {

    const { width } = useWindowSize()
    const {
        activeTab, activeType,
        setActiveTab, setActiveType,
        buyInput, setBuyInput,
        sellInput, setSellInput,
        onOperationClicked,
        invoice, onInvoiceClosed,
        validTrade, ocoError
    } = useTradingSpot()

    return (
        <>
            <TradingBox>
                <TradeWrapper>
                    <TradeHead>
                        <FlexCenter height="100%">
                            <Text tid="spot" />
                        </FlexCenter>
                    </TradeHead>
                    {(width > MOBILE_SIZE && width < TABLET_SIZE) &&
                        <FlexCenter>
                            <TypeWrapper>
                                {types.map(type => (
                                    <TypeTab
                                        active={activeType === type}
                                        type={type}
                                        onClick={() => setActiveType(type)}
                                    >
                                        <Text tid={type} />
                                    </TypeTab>
                                ))}
                            </TypeWrapper>
                        </FlexCenter>
                    }
                    <div>
                        <Padding padding="15px">
                            <FlexStart>
                                {tabs.map((tab, idx) => (
                                    <HText
                                        key={tab}
                                        onClick={() => setActiveTab(idx)}
                                        active={activeTab === idx}
                                        style={{ margin: "0 7px" }}
                                    >
                                        {tab}
                                    </HText>
                                ))}
                            </FlexStart>
                        </Padding>
                    </div>

                    <FlexCenter>
                        {width > TABLET_SIZE &&
                            <>
                                {/* buy section */}
                                <TradeType
                                    type="buy"
                                    activeTab={activeTab}
                                    userInput={buyInput}
                                    setUserInput={setBuyInput}
                                    onOperationClicked={(limitsError, limits) => onOperationClicked("buy", limitsError, limits)}
                                    valid={validTrade.buy}
                                    ocoError={ocoError}
                                />

                                {/* sell section */}
                                <TradeType
                                    type="sell"
                                    activeTab={activeTab}
                                    userInput={sellInput}
                                    setUserInput={setSellInput}
                                    onOperationClicked={(limitsError, limits) => onOperationClicked("sell", limitsError, limits)}
                                    valid={validTrade.sell}
                                    ocoError={ocoError}
                                />
                            </>
                        }
                        {(width < TABLET_SIZE && width > MOBILE_SIZE) &&
                            <TradeType
                                type={activeType}
                                activeTab={activeTab}
                                userInput={activeType === "buy" ? buyInput : sellInput}
                                setUserInput={activeType === "buy" ? setBuyInput : setSellInput}
                                onOperationClicked={(limitsError, limits) => onOperationClicked(activeType, limitsError, limits)}
                                valid={validTrade[activeType]}
                                ocoError={ocoError}
                            />
                        }

                    </FlexCenter>
                </TradeWrapper>
            </TradingBox>
            <ModalLayout
                open={invoice.visible}
                onClose={onInvoiceClosed}
            >
                <Invoice
                    data={invoice.type === "buy" ? buyInput : sellInput}
                    type={invoice.type}
                    tab={activeTab}
                    onClose={onInvoiceClosed}
                />
            </ModalLayout>
        </>
    )
}

const tabs = [
    "Limit", "Market", "Stop limit", "Oco"
]

const types = [
    "buy", "sell"
]

export default TradingComp;
